module.exports = __webpack_public_path__ + "img/hlxm.a05690a7.png";